import PythonApi from '@/services/PythonApi'

export default {
  index() {
    return PythonApi().get('groups')
  },
  show(groupID) {
    return PythonApi().get(`groups/${groupID}`)
  },
  post(group) {
    return PythonApi().post('groups', group)
  },
  put(group) {
    return PythonApi().put(`groups/${group.group_id}`, group)
  },
  delete(groupID) {
    return PythonApi().delete(`groups/${groupID}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/groups-api.js